import react, { Component } from "react";
import { Button, Modal, Breadcrumb } from "react-bootstrap";
import { connect } from "react-redux";
import Select from "react-select";
import Spinner from "react-bootstrap/Spinner";
import DatePicker from "react-date-picker";
import FloatingButton from "../../Material/FloatingButton";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import * as moment from "moment";
import { apiFetch } from "../../../apiFetch";

class EmployeeDelegation extends Component {
  constructor(props) {
    super(props);

    let encryptedId = this.props.location.search;

    var CryptoJS = require("crypto-js");
    var bytes = CryptoJS.AES.decrypt(
      encryptedId.replace("?p=", ""),
      process.env.REACT_APP_ENCRYPT_PASSWORD
    );

    var decryptedId = encryptedId
      ? JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
      : "";

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
      className: "text-danger",
    });
    this.state = {
      ModeofInput: "Referenceno",
      SectionlistArray: [],
      StaffDetailslistArray: [],
      PendingGGPapproverList: [],
      PendingGGPrefnoList: [],
      renderingreferarray: [],
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupdelegationEmployeeId: "",
      popupdelegationEmployeeName: "",
      popupdelegationreferEmployeeId: "",
      popupdelegationreferEmployeeName: "",
      delegatedid: "",
      delegatedname: "",
      delegatedreferid: "",
      delegatedrefername: "",
      Inspectedbydisplay: "",
      delegateddisplay: "",
      delegatedreferdisplay: "",
      popupdelegationSection: "",
      popupdelegationreferSection: "",
      popupSection: "",
      indefofrefer: "",
      iseditreferno: "",
      iseditappid: "",
      iseditappname: "",
      iseditcreatedate: "",
      editarrayobj: "",
      txtreferno: decryptedId ? decryptedId : "",
      referdate: new Date(),
      Inspectedbypopup: false,
      delagationpopup: false,
      delagationpopuprefer: false,
      stafflistArraySpin: "none",
      chnagebuttonstatus: "disable",
      fromdate: new Date(),
      todate: new Date(),
      checkedsave: "no",
      selectedsavevalue: [],
      datechanged: "no",
      toastercheck: "no",
    };
  }

  componentDidMount = () => {
    this.props.dispatch({ type: "headerTitle", value: "Delegation" });
    this.GetSectionListData();
    this.pendingReferencenolist();
  };

  handlechange = (e) => {
    switch (e.target.name) {
      case "ApprovalType":
        this.setState({ ModeofInput: e.target.value });
        break;
      case "popupEmployeeId":
        this.setState({ popupEmployeeId: e.target.value });
        break;
      case "popupEmployeeName":
        this.setState({ popupEmployeeName: e.target.value });
        break;
      case "popupdelegationEmployeeId":
        this.setState({ popupdelegationEmployeeId: e.target.value });
        break;
      case "popupdelegationEmployeeName":
        this.setState({ popupdelegationEmployeeName: e.target.value });
        break;
      case "popupdelegationreferEmployeeId":
        this.setState({ popupdelegationreferEmployeeId: e.target.value });
        break;
      case "popupdelegationreferEmployeeName":
        this.setState({ popupdelegationreferEmployeeName: e.target.value });
        break;
      case "txtreferno":
        this.setState({ txtreferno: e.target.value }, () =>
          this.pendingReferencenolist()
        );
        break;

      default:
        break;
    }
  };

  pendingReferencenolist = () => {
    let postData = {
      Userid: this.props.UserId,
      UserType: this.props.userType,
      Referenceno: this.state.txtreferno ? this.state.txtreferno : "G",
      Submitteddate:
        this.state.datechanged === "yes"
          ? moment(this.state.referdate).format("YYYY-MM-DD")
          : null,
    };

    apiFetch(
      process.env.REACT_APP_WEB_SERVICE_URL +
        "/api/AccessPrivilege/GetPendingGGPList",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        if (data) {
          this.setState({ PendingGGPrefnoList: data.PendingGGPList });
          let referdummmtarray = [];
          this.state.PendingGGPrefnoList.map((value) => {
            let rdata = {
              refer: value.Referenceno,
              originalapproverarray: value.ChargeTo,
              opid: value.Oriapproverid,
              opname: value.Oriapprovername,
              submiteddate: value.Submitteddate,
              delval: value.Delegatetoempid
                ? value.Delegatetoempid + " - " + value.Delegatetoname
                : "",
              delegateid: value.Delegatetoempid,
              delegatename: value.Delegatetoname,
              craete: value.Createddate,
              checked: "no",
            };
            referdummmtarray.push(rdata);
            return null;
          });

          this.setState({ renderingreferarray: referdummmtarray });
        }
      })

      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  GetSectionListData = (val) => {
    // alert('a')
    let postData = { Mode: "Section" };
    apiFetch(process.env.REACT_APP_WEB_SERVICE_URL + "/api/GGP/GetGGPMaster", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.props.getToken,
      },
      body: JSON.stringify(postData),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        if (data) {
          this.setState({ SectionlistArray: data.MasterList });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.searchEmployee();
      this.searchdelegationreferEmployee();
      this.searchdelegationEmployee();
    }
  };

  referdatechange = (date) => {
    this.setState({ referdate: date, datechanged: "yes" }, () =>
      this.pendingReferencenolist()
    );
  };

  fromdatechange = (date) => {
    this.setState({ fromdate: date });
  };

  todatechange = (date) => {
    this.setState({ todate: date });
  };

  handledelegationSelectFormFieldsrefer = (selectedOption) => {
    this.setState({ popupdelegationreferSection: selectedOption.value });
  };

  handledelegationSelectFormFields = (selectedOption) => {
    this.setState({ popupdelegationSection: selectedOption.value });
  };

  handleSelectFormFields = (selectedOption) => {
    this.setState({ popupSection: selectedOption.value });
  };

  approversubmit = () => {
    if (this.validator.allValid()) {
      if (this.state.Inspectedby === this.state.delegatedid) {
        this.setState({
          delegatedid: "",
          delegatedname: "",
          delegateddisplay: "",
        });
        toast.error("Approver by and delegated by can't be same person", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      } else {
        let postData = {
          TypeofMode: "Approver Name",
          Originalapproverid: this.state.Inspectedby,
          Originalapprovername: this.state.Inspectedbyname,
          Delegatetoempid: this.state.delegatedid,
          Delegatetoname: this.state.delegatedname,
          Fromdate: this.state.fromdate,
          Todate: this.state.todate,
          Createdby: this.props.UserId,
          Createdbyname: this.props.userName,
          Mode: "Add",
        };
        apiFetch(
          process.env.REACT_APP_WEB_SERVICE_URL +
            "/api/AccessPrivilege/InsertUpdateDelegatedApprovers",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
            body: JSON.stringify(postData),
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
            }
          })
          .then((data) => {
            // console.log(data)
            if (data) {
              if (data.Status === "Success") {
                this.setState({
                  Inspectedby: "",
                  Inspectedbyname: "",
                  delegatedid: "",
                  delegatedname: "",
                  delegateddisplay: "",
                  Inspectedbydisplay: "",
                  fromdate: new Date(),
                  todate: new Date(),
                  chnagebuttonstatus: "disable",
                  PendingGGPapproverList: [],
                });
                toast.success("Created successfully.", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
                this.props.history.push({ pathname: "/Delegation/list" });
                this.validator.hideMessages();
              } else {
                // console.log(JSON.stringify(postData))
                toast.error(data.Message, {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
              }
            }
          })
          .catch((error) => {
            console.log(error);
            this.props.history.push({ pathname: "/somethingwrong" });
          });
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  searchdelegationreferEmployee = () => {
    // alert('a')
    this.setState({ stafflistArraySpin: "", StaffDetailslistArray: [] });
    let postData = {
      EmployeeId: this.state.popupdelegationreferEmployeeId,
      Name: this.state.popupdelegationreferEmployeeName,
      Section: this.state.popupdelegationreferSection,
    };
    apiFetch(
      process.env.REACT_APP_WEB_SERVICE_URL + "/api/GGP/GetStaffDetails",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        //console.log(data)
        if (data) {
          this.setState({
            StaffDetailslistArray: data.StaffDetails,
            stafflistArraySpin: "none",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  searchdelegationEmployee = () => {
    // alert('a')
    this.setState({ stafflistArraySpin: "", StaffDetailslistArray: [] });
    let postData = {
      EmployeeId: this.state.popupdelegationEmployeeId,
      Name: this.state.popupdelegationEmployeeName,
      Section: this.state.popupdelegationSection,
    };
    apiFetch(
      process.env.REACT_APP_WEB_SERVICE_URL + "/api/GGP/GetStaffDetails",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        //console.log(data)
        if (data) {
          this.setState({
            StaffDetailslistArray: data.StaffDetails,
            stafflistArraySpin: "none",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  searchEmployee = () => {
    // alert('a')
    this.setState({ stafflistArraySpin: "", StaffDetailslistArray: [] });
    let postData = {
      EmployeeId: this.state.popupEmployeeId,
      Name: this.state.popupEmployeeName,
      Section: this.state.popupSection,
    };
    apiFetch(
      process.env.REACT_APP_WEB_SERVICE_URL + "/api/GGP/GetStaffDetails",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        //console.log(data)
        if (data) {
          this.setState({
            StaffDetailslistArray: data.StaffDetails,
            stafflistArraySpin: "none",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  searchEmployeeClear = () => {
    this.setState({
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: "",
      StaffDetailslistArray: [],
      stafflistArraySpin: "none",
    });
  };

  getInspectedbyshow = () => {
    this.setState({
      Inspectedbypopup: true,
      popupEmployeeId: "",
      popupEmployeeName: "",
      stafflistArraySpin: "none",
    });
  };

  getInspectedbyhide = () => {
    this.setState({
      Inspectedbypopup: false,
      popupEmployeeId: "",
      popupEmployeeName: "",
    });
  };

  getInspectedbyDetails = (id, name) => {
    this.setState({
      Inspectedby: id,
      Inspectedbyname: name,
      Inspectedbydisplay: id + " - " + name,
      Inspectedbypopup: false,
      chnagebuttonstatus: "disable",
    });
    this.setState({
      popupEmployeeId: "",
      popupEmployeeName: "",
      popupSection: "",
      StaffDetailslistArray: [],
    });

    let postData = {
      Userid: this.props.UserId,
      UserType: this.props.userType,
      Approverid: id,
    };
    apiFetch(
      process.env.REACT_APP_WEB_SERVICE_URL +
        "/api/AccessPrivilege/GetPendingGGPList",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        if (data) {
          this.setState({ PendingGGPapproverList: data.PendingGGPList });
          if (this.state.PendingGGPapproverList.length > 0) {
            this.setState({ chnagebuttonstatus: "" });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  //delegation
  searchdelegationEmployeeClear = () => {
    this.setState({
      popupdelegationEmployeeId: "",
      popupdelegationEmployeeName: "",
      popupdelegationSection: "",
      StaffDetailslistArray: [],
      stafflistArraySpin: "none",
    });
  };

  getdelegationshow = () => {
    this.setState({
      delagationpopup: true,
      popupdelegationEmployeeId: "",
      popupdelegationEmployeeName: "",
      stafflistArraySpin: "none",
    });
  };

  getdelegationhide = () => {
    this.setState({
      delagationpopup: false,
      popupdelegationEmployeeId: "",
      popupdelegationEmployeeName: "",
    });
  };

  getdelegationDetails = (id, name) => {
    this.setState({
      delegatedid: id,
      delegatedname: name,
      delegateddisplay: id + " - " + name,
      delagationpopup: false,
    });
    this.setState({
      popupdelegationEmployeeId: "",
      popupdelegationEmployeeName: "",
      popupdelegationSection: "",
      StaffDetailslistArray: [],
    });
  };

  //delegation reference no

  searchdelegationreferEmployeeClear = () => {
    this.setState({
      popupdelegationreferEmployeeId: "",
      popupdelegationreferEmployeeName: "",
      popupdelegationSection: "",
      StaffDetailslistArray: [],
      stafflistArraySpin: "none",
    });
  };

  getdelegationrefershow = (val, i) => {
    if (val.opid) {
      this.setState({
        iseditsubmittedate: val.submiteddate,
        iseditreferno: val.refer,
        iseditappid: val.opid,
        iseditappname: val.opname,
        iseditcreatedate: val.craete,
        indefofrefer: i,
        editarrayobj: val,
      });

      this.setState({
        delagationpopuprefer: true,
        popupdelegationreferEmployeeId: "",
        popupdelegationreferEmployeeName: "",
        stafflistArraySpin: "none",
      });
    } else {
      toast.error("Please select a Approver Person", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  getdelegationreferhide = () => {
    this.setState({
      delagationpopuprefer: false,
      popupdelegationreferEmployeeId: "",
      popupdelegationreferEmployeeName: "",
    });
  };

  getdelegationreferDetails = (id, name) => {
    if (this.state.iseditappid == id) {
      toast.error("Approver by and delegated by can't be same person", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } else {
      let insertedit = {
        refer: this.state.iseditreferno,
        opid: this.state.iseditappid,
        opname: this.state.iseditappname,
        submiteddate: this.state.iseditsubmittedate,
        delval: id + " - " + name,
        delegateid: id,
        delegatename: name,
        craete: this.state.iseditcreatedate,
        checked: "yes",
      };

      let editingarrayfull = this.state.renderingreferarray;
      editingarrayfull.splice(this.state.indefofrefer, 1, insertedit);

      this.setState({
        delagationpopuprefer: false,
        popupdelegationreferEmployeeId: "",
        popupdelegationreferEmployeeName: "",
        popupdelegationSection: "",
        StaffDetailslistArray: [],
        checkedsave: insertedit.checked,
      });
    }
  };

  removedel = (value, index) => {
    let insertedit = {
      refer: value.refer,
      opid: value.opid,
      opname: value.opname,
      submiteddate: value.submiteddate,
      delval: "",
      delegateid: "",
      delegatename: "",
      craete: value.craete,
      checked: "no",
    };

    let editingarrayfull = this.state.renderingreferarray;
    editingarrayfull.splice(index, 1, insertedit);

    this.setState({ renderingreferarray: editingarrayfull });

    var savecheck = "no";
    this.state.renderingreferarray.map((data) => {
      if (data.checked === "yes") {
        savecheck = "yes";
      }
    });

    if (savecheck === "yes") {
      this.setState({ checkedsave: "yes" });
    } else {
      this.setState({ checkedsave: "no" });
    }

    // if( value.delegateid ==="" ){

    //   toast.error("Please select a delegate person", {
    //     position: toast.POSITION.TOP_CENTER,
    //     autoClose: 2000,
    //   });
    // }else{

    //     let postData = {
    //       TypeofMode : "GGP-ReferenceNo",
    //       Originalapproverid : value.opid,
    //       Originalapprovername : value.opname,
    //       Delegatetoempid : "",
    //       Delegatetoname : "",
    //       Createdby : this.props.UserId,
    //       Createdbyname : this.props.userName,
    //       Referenceno : value.refer,
    //       Mode: "Delete",
    //     }
    //     apiFetch(process.env.REACT_APP_WEB_SERVICE_URL + '/api/AccessPrivilege/InsertUpdateDelegatedApprovers', {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': 'Bearer ' + this.props.getToken,
    //       },
    //       body: JSON.stringify(postData)
    //       }).then(response=>{
    //         if(response.status === 200){
    //             return response.json()
    //         }else if(response.status === 401){
    //             this.props.dispatch({ type: 'Token', value: "" });
    //             this.props.dispatch({ type: 'profile', value: "" });
    //             this.props.dispatch({ type: 'userType', value: "" });
    //         }
    //       })
    //       .then(data => {
    //         if(data){
    //           if(data.Status === "Success"){
    //             let insertedits = {
    //               refer : value.refer,
    //               submiteddate : value.submiteddate,
    //               opid : value.opid,
    //               opname : value.opname,
    //               delval : "",
    //               delegateid : "",
    //               delegatename : "",
    //               craete : value.craete,
    //             }

    //             let editingarrayfulls = this.state.renderingreferarray
    //             editingarrayfulls.splice(index,1 ,insertedits)
    //             this.setState({renderingreferarray:editingarrayfulls})

    //             toast.success("Deleted successfully.", {
    //               position: toast.POSITION.TOP_CENTER,
    //               autoClose: 2000,
    //             });
    //           }else{
    //             toast.error(data.Message, {
    //               position: toast.POSITION.TOP_CENTER,
    //               autoClose: 2000,
    //             });
    //           }
    //         }
    //       })
    //       .catch(error =>{
    //         console.log(error);
    //          this.props.history.push({pathname:"/somethingwrong"})
    //       })
    // }
  };

  savereference = () => {
    this.state.renderingreferarray.map((data, index) => {
      if (data.checked === "yes") {
        let insertedits = {
          refer: data.refer,
          opid: data.opid,
          opname: data.opname,
          submiteddate: data.submiteddate,
          delval: data.delval,
          delegateid: data.delegateid,
          delegatename: data.delegatename,
          craete: data.craete,
        };

        this.state.selectedsavevalue.push(insertedits);
        return null;
      }
    });

    this.state.selectedsavevalue.map((datas) => {
      let postData = {
        TypeofMode: "GGP-ReferenceNo",
        Originalapproverid: datas.opid,
        Originalapprovername: datas.opname,
        Delegatetoempid: datas.delegateid,
        Delegatetoname: datas.delegatename,
        Createdby: this.props.UserId,
        Createdbyname: this.props.userName,
        Referenceno: datas.refer,
        Mode: "Add",
      };
      apiFetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          "/api/AccessPrivilege/InsertUpdateDelegatedApprovers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
          body: JSON.stringify(postData),
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            if (data.Status === "Success") {
              this.setState({ toastercheck: "yes" });
            } else {
              toast.error(datas.refer + "its not delegated", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.props.history.push({ pathname: "/somethingwrong" });
        });
    });
    toast.success("Delegated successfully.", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });

    this.props.history.push({ pathname: "/Delegation/list" });
  };

  refersave = (value, index) => {
    if (value.delegateid === "" || value.delegateid === null) {
      toast.error("Please select a delegated person", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } else {
      if (value.opid !== value.delegateid) {
        let postData = {
          TypeofMode: "GGP-ReferenceNo",
          Originalapproverid: value.opid,
          Originalapprovername: value.opname,
          Delegatetoempid: value.delegateid,
          Delegatetoname: value.delegatename,
          Createdby: this.props.UserId,
          Createdbyname: this.props.userName,
          Referenceno: value.refer,
          Mode: "Add",
        };
        apiFetch(
          process.env.REACT_APP_WEB_SERVICE_URL +
            "/api/AccessPrivilege/InsertUpdateDelegatedApprovers",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
            body: JSON.stringify(postData),
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
            }
          })
          .then((data) => {
            if (data) {
              if (data.Status === "Success") {
                toast.success("Delegated successfully.", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
                this.props.history.push({ pathname: "/Delegation/list" });
              } else {
                toast.error(data.Message, {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
              }
            }
          })
          .catch((error) => {
            console.log(error);
            this.props.history.push({ pathname: "/somethingwrong" });
          });
      } else {
        toast.error("Approver by and delegated by can't be same person", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        this.pendingReferencenolist();
      }
    }
  };

  origiappchange = (e) => {
    var opar = e.target.value;
    let splitted_value = opar.split(":");

    let originalapproveridselected = splitted_value[0];
    let originalapprovernameselected = splitted_value[1];
    let parentarrayvalue = this.state.renderingreferarray[splitted_value[2]];

    // this.setState({renderingreferarray[].})
    // parentarrayvalue.opid = originalapproveridselected
    // parentarrayvalue.opname = originalapprovernameselected

    let insertedits = {
      refer: parentarrayvalue.refer,
      originalapproverarray: parentarrayvalue.originalapproverarray,
      opid: originalapproveridselected,
      opname: originalapprovernameselected,
      submiteddate: parentarrayvalue.submiteddate,
      delval: parentarrayvalue.delval,
      delegateid: parentarrayvalue.delegateid,
      delegatename: parentarrayvalue.delegatename,
      craete: parentarrayvalue.craete,
    };

    let editingarrayfulls = this.state.renderingreferarray;
    editingarrayfulls.splice(splitted_value[2], 1, insertedits);

    this.setState({ renderingreferarray: editingarrayfulls });
  };

  render() {
    let sectionOptionList = [];
    if (this.state.SectionlistArray) {
      this.state.SectionlistArray.map((data) => {
        let sData = { id: "popupSection", label: data.Code, value: data.Code };
        sectionOptionList.push(sData);
        return null;
      });
    }

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item
            href={process.env.REACT_APP_ENV + "/Delegation/list"}>
            Delegation
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Create</Breadcrumb.Item>
        </Breadcrumb>

        <div className="content-area shadow p-3 mb-5 bg-white rounded">
          <h2 className="fs-title mb-2 mb-sm-4">Delegation</h2>
          <div className="form-group ">
            <label
              for="auth-name"
              className="col-sm-2 pl-0 col-form-label text-muted">
              Type of Mode
            </label>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="ApprovalType"
                value="Referenceno"
                id="ApprovalType"
                defaultChecked
                onChange={this.handlechange}
              />
              <label className="form-check-label text-muted" for="ApprovalType">
                {" "}
                GGP-Referenceno{" "}
              </label>
            </div>
            <div className="form-check form-check-inline ml-sm-5">
              <input
                className="form-check-input"
                type="radio"
                name="ApprovalType"
                id="ApprovalType1"
                value="CurrentName"
                onChange={this.handlechange}
              />
              <label
                className="form-check-label text-muted"
                for="ApprovalType1">
                {" "}
                Approver Name{" "}
              </label>
            </div>
          </div>

          {(() => {
            if (this.state.ModeofInput === "Referenceno") {
              return (
                <>
                  <div className="row ml-auto">
                    <div className="col-sm-4"> </div>
                    <div className="col-sm-3">
                      <div className="input-group mb-3 search-field">
                        <DatePicker
                          format="dd-MM-y"
                          onChange={this.referdatechange}
                          className="date-picker-style form-control"
                          value={new Date(this.state.referdate)}
                        />
                      </div>
                    </div>

                    <div className="col-sm-4">
                      <div className="mb-3 search-field">
                        <input
                          type="search"
                          placeholder="Search"
                          className="form-control"
                          name="txtreferno"
                          value={this.state.txtreferno}
                          Autocomplete="off"
                          onChange={this.handlechange}
                          aria-label=""
                          aria-describedby="basic-addon1"
                        />
                      </div>
                    </div>
                    {(() => {
                      if (this.state.checkedsave === "yes") {
                        return (
                          <div
                            className="col-sm-1 text-right"
                            style={{ display: "block" }}>
                            <button
                              type="button"
                              style={{ float: "right" }}
                              className="btn btn-primary"
                              onClick={() => {
                                this.savereference();
                              }}>
                              {" "}
                              Save
                            </button>
                          </div>
                        );
                      }
                    })()}
                  </div>
                  <div class="pane pane--table1">
                    <div class="pane-hScroll">
                      <table className="table table-hover table-fixed">
                        <thead className="thead-lightBlue">
                          <tr>
                            <th scope="col"> Reference No </th>
                            <th scope="col"> Submitted Date</th>
                            <th scope="col"> Original Approver </th>
                            <th scope="col"> Delegate To </th>

                            <th scope="col" className="position-relative">
                              {" "}
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.renderingreferarray.map(
                            (value, indexParent) => (
                              <tr>
                                <td> {value.refer} </td>
                                <td>
                                  {" "}
                                  {value.submiteddate
                                    ? moment(value.submiteddate).format(
                                        "DD-MM-yyyy HH:mm:ss"
                                      )
                                    : ""}{" "}
                                </td>

                                {(() => {
                                  if (value.opid) {
                                    return (
                                      <td>
                                        {" "}
                                        {value.opid} - {value.opname}{" "}
                                      </td>
                                    );
                                  } else {
                                    return (
                                      <td>
                                        <select
                                          className="form-control classic classicSelect"
                                          name=""
                                          value={
                                            this.state.selectedoriginalapprover
                                          }
                                          onChange={this.origiappchange}>
                                          <option> Please select </option>
                                          {value?.originalapproverarray?.map(
                                            (loopdata, index) => (
                                              <option
                                                value={
                                                  loopdata.Oriapproverid +
                                                  ":" +
                                                  loopdata.Oriapprovername +
                                                  ":" +
                                                  indexParent
                                                }>
                                                {" "}
                                                {loopdata.Oriapprovername}{" "}
                                              </option>
                                            )
                                          )}
                                        </select>{" "}
                                      </td>
                                    );
                                  }
                                })()}

                                {(() => {
                                  if (value.delegateid) {
                                    return (
                                      <>
                                        <td>{value.delval}</td>
                                      </>
                                    );
                                  } else {
                                    return (
                                      <>
                                        <td>
                                          <div className="input-group">
                                            <input
                                              type="text"
                                              className="form-control"
                                              id=""
                                              placeholder=""
                                              readOnly={true}
                                              value={value.delval}
                                              onClick={() =>
                                                this.getdelegationrefershow(
                                                  value,
                                                  indexParent
                                                )
                                              }
                                            />
                                            <div className="input-group-prepend">
                                              <div className="input-group-text">
                                                <i
                                                  className="fa fa-search text-muted"
                                                  onClick={() =>
                                                    this.getdelegationrefershow(
                                                      value,
                                                      indexParent
                                                    )
                                                  }>
                                                  {" "}
                                                </i>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </>
                                    );
                                  }
                                })()}

                                {(() => {
                                  if (value.checked === "yes") {
                                    return (
                                      <>
                                        <td>
                                          {/* <img className="action-right-space mouse-pointer" style={{width: "25px"}} src={process.env.REACT_APP_ENV +"/assets/images/icons/action/Icon-feather-check.svg"} data-tip="confirm"data-tip="View" /> */}

                                          <img
                                            className="action-right-space mouse-pointer"
                                            src={
                                              process.env.REACT_APP_ENV +
                                              "/assets/images/icons/action/ionic-md-close.svg"
                                            }
                                            data-tip="Delete"
                                            alt="Close"
                                            onClick={() =>
                                              this.removedel(value, indexParent)
                                            }
                                          />
                                        </td>
                                      </>
                                    );
                                  } else {
                                    return (
                                      <>
                                        <td>
                                          {/* <img className="action-right-space mouse-pointer" style={{width: "25px"}} src={process.env.REACT_APP_ENV +"/assets/images/icons/action/Icon-feather-check.svg"} data-tip="confirm"data-tip="View" /> */}

                                          <img
                                            className="action-right-space mouse-pointer"
                                            src={
                                              process.env.REACT_APP_ENV +
                                              "/assets/images/icons/action/ionic-md-close.svg"
                                            }
                                            data-tip="Delete"
                                            alt="Close"
                                            onClick={() =>
                                              this.removedel(value, indexParent)
                                            }
                                          />
                                        </td>
                                      </>
                                    );
                                  }
                                })()}
                              </tr>
                            )
                          )}{" "}
                        </tbody>
                      </table>
                      {(() => {
                        if (this.state.renderingreferarray.length <= 0) {
                          return (
                            <p className="text-center">
                              Sorry there is no data
                            </p>
                          );
                        }
                      })()}

                      {/* <div class="pane-vScroll">
                        <table></table>
                      </div> */}
                    </div>
                  </div>
                </>
              );
            } else {
              return (
                <>
                  <div className="form-group row mb-2">
                    <label
                      for="auth-name"
                      className="col-sm-2 col-form-label text-muted">
                      Original Approver
                    </label>

                    <div className="col-sm-3">
                      <div className="form-group">
                        <div className="input-group mb-2">
                          <input
                            type="text"
                            className="form-control"
                            id=""
                            placeholder=""
                            readOnly={true}
                            value={this.state.Inspectedbydisplay}
                            onClick={this.getInspectedbyshow}
                          />
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <i
                                className="fa fa-search text-muted"
                                onClick={this.getInspectedbyshow}>
                                {" "}
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row mb-2">
                    <div className="col-sm-2"> </div>
                    <div className="col-sm-5">
                      {this.validator.message(
                        "Approver",
                        this.state.Inspectedbydisplay,
                        "required"
                      )}
                    </div>
                  </div>

                  <div className="form-group row mb-2">
                    <label
                      for="auth-name"
                      className="col-sm-2 col-form-label text-muted">
                      Delegate To
                    </label>

                    <div className="col-sm-3">
                      <div className="form-group">
                        <div className="input-group mb-2">
                          <input
                            type="text"
                            className="form-control"
                            id=""
                            placeholder=""
                            readOnly={true}
                            value={this.state.delegateddisplay}
                            onClick={this.getdelegationshow}
                          />
                          <div className="input-group-prepend">
                            <div className="input-group-text">
                              <i
                                className="fa fa-search text-muted"
                                onClick={this.getdelegationshow}>
                                {" "}
                              </i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row mb-2">
                    <div className="col-sm-2"> </div>
                    <div className="col-sm-5">
                      {this.validator.message(
                        "Delegate To",
                        this.state.delegateddisplay,
                        "required"
                      )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      for=""
                      className="col-sm-2 col-form-label text-muted">
                      {" "}
                      From Date
                    </label>
                    <div className="col-sm-4">
                      <div className="input-group mb-2 mr-sm-2">
                        <DatePicker
                          format="dd-MM-y"
                          onChange={this.fromdatechange}
                          minDate={new Date()}
                          className="date-picker-style form-control"
                          value={new Date(this.state.fromdate)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group row mb-2">
                    <div className="col-sm-2"> </div>
                    <div className="col-sm-5">
                      {this.validator.message(
                        "From Date",
                        this.state.fromdate,
                        "required"
                      )}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label
                      for=""
                      className="col-sm-2 col-form-label text-muted">
                      {" "}
                      To Date
                    </label>
                    <div className="col-sm-4">
                      <div className="input-group mb-2 mr-sm-2">
                        <DatePicker
                          format="dd-MM-y"
                          onChange={this.todatechange}
                          minDate={new Date(this.state.fromdate)}
                          className="date-picker-style form-control"
                          value={new Date(this.state.todate)}
                        />
                      </div>
                    </div>

                    <div className="col-lg-12">
                      {" "}
                      <hr></hr>
                      <div className="col-lg-12 text-right">
                        <button
                          type="button"
                          className="btn btn-primary-01 px-5"
                          disabled={
                            this.state.chnagebuttonstatus === "disable"
                              ? true
                              : false
                          }
                          className={`${
                            this.state.chnagebuttonstatus === "disable"
                              ? "btn btn-secondary"
                              : "btn btn-primary-01"
                          }`}
                          onClick={this.approversubmit}>
                          {" "}
                          Change
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row mb-2">
                    <div className="col-sm-2"> </div>
                    <div className="col-sm-5">
                      {this.validator.message(
                        "To Date",
                        this.state.todate,
                        "required"
                      )}
                    </div>
                  </div>

                  <div className="table-responsive ">
                    <table className="table table-hover">
                      <thead className="thead-lightBlue">
                        <tr>
                          <th scope="col"> Referenceno </th>
                          <th scope="col"> Submitted Date </th>
                          <th scope="col"> Original Approver </th>
                          <th scope="col"> Delegated to </th>
                          <th scope="col"> From Date </th>
                          <th scope="col"> To Date</th>
                        </tr>
                      </thead>
                      {(() => {
                        if (this.state.PendingGGPapproverList.length > 0) {
                          return (
                            <>
                              <tbody>
                                {this.state.PendingGGPapproverList.map(
                                  (value, index) => (
                                    <tr>
                                      <td> {value.Referenceno} </td>
                                      <td>
                                        {value.Submitteddate
                                          ? moment(value.Submitteddate).format(
                                              "DD-MM-yyyy HH:mm:ss"
                                            )
                                          : ""}
                                      </td>
                                      <td>
                                        {" "}
                                        {value.Oriapproverid} -{" "}
                                        {value.Oriapprovername}{" "}
                                      </td>
                                      <td>
                                        {" "}
                                        {value.Delegatetoempid} -{" "}
                                        {value.Delegatetoname}{" "}
                                      </td>
                                      <td> {value.Fromdate} </td>
                                      <td> {value.Todate} </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </>
                          );
                        }
                      })()}
                    </table>
                    {(() => {
                      if (this.state.PendingGGPapproverList.length <= 0) {
                        return (
                          <p className="text-center">Sorry there is no data</p>
                        );
                      }
                    })()}
                  </div>
                </>
              );
            }
          })()}
        </div>

        <Modal show={this.state.Inspectedbypopup} size="lg">
          <Modal.Header>Employee Look Up</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Id
                </label>
                <div className="col-sm-4">
                  <div className="form-group">
                    <input
                      type="number"
                      Autocomplete="off"
                      className="form-control"
                      name="popupEmployeeId"
                      value={this.state.popupEmployeeId}
                      onChange={this.handlechange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Name
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      Autocomplete="off"
                      className="form-control"
                      name="popupEmployeeName"
                      value={this.state.popupEmployeeName}
                      onChange={this.handlechange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-cat"
                  className="col-sm-3 col-form-label text-muted">
                  Section
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Select
                      options={sectionOptionList}
                      onChange={this.handleSelectFormFields}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={() => this.searchEmployeeClear()}>
                  {" "}
                  Clear{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.searchEmployee}>
                  {" "}
                  Search{" "}
                </Button>
              </div>
            </section>
            <hr></hr>
            <section>
              <h2 className="fs-title"> </h2>
              <div className="table-responsive max-height-280">
                <table className="table table-hover">
                  <thead className="thead-lightBlue">
                    <tr>
                      <th scope="col"> Action </th>
                      <th scope="col"> Employee No </th>
                      <th scope="col"> User Name </th>
                      <th scope="col"> Account </th>
                      <th scope="col"> Email </th>
                      <th scope="col"> Section </th>
                      <th scope="col"> Section Name </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.StaffDetailslistArray.map((staff, index) => (
                      <tr
                        onClick={() =>
                          this.getInspectedbyDetails(
                            staff.EmployeeId,
                            staff.Name
                          )
                        }
                        className="cursor-pointer">
                        <td>
                          {" "}
                          <p>
                            {" "}
                            <span className="material-icons-outlined select-employee-icon">
                              {" "}
                              how_to_reg{" "}
                            </span>{" "}
                          </p>{" "}
                        </td>
                        <td> {staff.EmployeeId} </td>
                        <td> {staff.Name} </td>
                        <td> ({staff.Account}) </td>
                        <td> {staff.Email} </td>
                        <td> {staff.Section} </td>
                        <td> {staff.SectionName} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {(() => {
                  if (
                    this.state.StaffDetailslistArray.length <= 0 &&
                    this.state.stafflistArraySpin === "none"
                  ) {
                    return <p className="text-center">No record found.</p>;
                  }
                })()}
                <p className="text-center">
                  <Spinner
                    animation="border"
                    variant="primary"
                    style={{ display: this.state.stafflistArraySpin }}
                    className="text-center"
                  />
                </p>
              </div>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-light"
              onClick={() => this.getInspectedbyhide()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.delagationpopup} size="lg">
          <Modal.Header>Employee Look Up</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Id
                </label>
                <div className="col-sm-4">
                  <div className="form-group">
                    <input
                      type="number"
                      Autocomplete="off"
                      className="form-control"
                      name="popupdelegationEmployeeId"
                      value={this.state.popupdelegationEmployeeId}
                      onChange={this.handlechange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Name
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      Autocomplete="off"
                      className="form-control"
                      name="popupdelegationEmployeeName"
                      value={this.state.popupdelegationEmployeeName}
                      onChange={this.handlechange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-cat"
                  className="col-sm-3 col-form-label text-muted">
                  Section
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Select
                      options={sectionOptionList}
                      onChange={this.handledelegationSelectFormFields}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={() => this.searchdelegationEmployeeClear()}>
                  {" "}
                  Clear{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.searchdelegationEmployee}>
                  {" "}
                  Search{" "}
                </Button>
              </div>
            </section>
            <hr></hr>
            <section>
              <h2 className="fs-title"> </h2>
              <div className="table-responsive max-height-280">
                <table className="table table-hover">
                  <thead className="thead-lightBlue">
                    <tr>
                      <th scope="col"> Action </th>
                      <th scope="col"> Employee No </th>
                      <th scope="col"> User Name </th>
                      <th scope="col"> Account </th>
                      <th scope="col"> Email </th>
                      <th scope="col"> Section </th>
                      <th scope="col"> Section Name </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.StaffDetailslistArray.map((staff, index) => (
                      <tr
                        onClick={() =>
                          this.getdelegationDetails(
                            staff.EmployeeId,
                            staff.Name
                          )
                        }
                        className="cursor-pointer">
                        <td>
                          {" "}
                          <p>
                            {" "}
                            <span className="material-icons-outlined select-employee-icon">
                              {" "}
                              how_to_reg{" "}
                            </span>{" "}
                          </p>{" "}
                        </td>
                        <td> {staff.EmployeeId} </td>
                        <td> {staff.Name} </td>
                        <td> ({staff.Account}) </td>
                        <td> {staff.Email} </td>
                        <td> {staff.Section} </td>
                        <td> {staff.SectionName} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {(() => {
                  if (
                    this.state.StaffDetailslistArray.length <= 0 &&
                    this.state.stafflistArraySpin === "none"
                  ) {
                    return <p className="text-center">No record found.</p>;
                  }
                })()}
                <p className="text-center">
                  <Spinner
                    animation="border"
                    variant="primary"
                    style={{ display: this.state.stafflistArraySpin }}
                    className="text-center"
                  />
                </p>
              </div>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-light"
              onClick={() => this.getdelegationhide()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.delagationpopuprefer} size="lg">
          <Modal.Header>Employee Look Up</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Id
                </label>
                <div className="col-sm-4">
                  <div className="form-group">
                    <input
                      type="number"
                      Autocomplete="off"
                      className="form-control"
                      name="popupdelegationreferEmployeeId"
                      value={this.state.popupdelegationreferEmployeeId}
                      onChange={this.handlechange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted">
                  Employee Name
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      Autocomplete="off"
                      className="form-control"
                      name="popupdelegationreferEmployeeName"
                      value={this.state.popupdelegationreferEmployeeName}
                      onChange={this.handlechange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-cat"
                  className="col-sm-3 col-form-label text-muted">
                  Section
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Select
                      options={sectionOptionList}
                      onChange={this.handledelegationSelectFormFieldsrefer}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={() => this.searchdelegationreferEmployeeClear()}>
                  {" "}
                  Clear{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.searchdelegationreferEmployee}>
                  {" "}
                  Search{" "}
                </Button>
              </div>
            </section>
            <hr></hr>
            <section>
              <h2 className="fs-title"> </h2>
              <div className="table-responsive max-height-280">
                <table className="table table-hover">
                  <thead className="thead-lightBlue">
                    <tr>
                      <th scope="col"> Action </th>
                      <th scope="col"> Employee No </th>
                      <th scope="col"> User Name </th>
                      <th scope="col"> Account </th>
                      <th scope="col"> Email </th>
                      <th scope="col"> Section </th>
                      <th scope="col"> Section Name </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.StaffDetailslistArray.map((staff, index) => (
                      <tr
                        onClick={() =>
                          this.getdelegationreferDetails(
                            staff.EmployeeId,
                            staff.Name
                          )
                        }
                        className="cursor-pointer">
                        <td>
                          {" "}
                          <p>
                            {" "}
                            <span className="material-icons-outlined select-employee-icon">
                              {" "}
                              how_to_reg{" "}
                            </span>{" "}
                          </p>{" "}
                        </td>
                        <td> {staff.EmployeeId} </td>
                        <td> {staff.Name} </td>
                        <td> ({staff.Account}) </td>
                        <td> {staff.Email} </td>
                        <td> {staff.Section} </td>
                        <td> {staff.SectionName} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {(() => {
                  if (
                    this.state.StaffDetailslistArray.length <= 0 &&
                    this.state.stafflistArraySpin === "none"
                  ) {
                    return <p className="text-center">No record found.</p>;
                  }
                })()}
                <p className="text-center">
                  <Spinner
                    animation="border"
                    variant="primary"
                    style={{ display: this.state.stafflistArraySpin }}
                    className="text-center"
                  />
                </p>
              </div>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-light"
              onClick={() => this.getdelegationreferhide()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <FloatingButton />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(EmployeeDelegation);
